import React from "react";
import { Spinner } from "react-bootstrap";

export const NO_RECORDS_FOUND = "No records found";

export const getNoMatchContent = (isLoading = false) =>
  isLoading ? <Spinner animation="border" size="sm" /> : NO_RECORDS_FOUND;
